import moment from "moment";

// External (ThunJai) orders — admin/manager cross-branch table.
// Data source: GET /api/admin/external-shipments (adminAxios = this.$axios),
// same list envelope as the branch app ({shipment:{data,current_page,...},
// totalFreight, total, totalPrice, serviceFeeTotal}).
export default {
    data() {
        return {
            listAllOrders: [],
            isLoading: true,
            count: 0,
            totalFreight: 0,
            totalPrice: 0,
            serviceFeeTotal: 0,

            // Filters
            searchItem: '',
            selectedStatusGroup: '',
            startBranches: [],
            selectedStartBranch: '',
            fromDate: moment(new Date()).subtract(7, 'days').format('YYYY-MM-DD'),
            toDate: moment(new Date()).format('YYYY-MM-DD'),

            // Pagination (offset-based — matches the admin endpoint's paginate())
            offset: 10,
            pagination: {},
            per_page: 20,

            loading: false,

            statusGroups: [
                {id: '', name: this.$t('common.ທັງໝົດ')},
                {id: 'pending', name: this.$t('externalShipments.status_pending')},
                {id: 'processing', name: this.$t('externalShipments.status_processing')},
                {id: 'success', name: this.$t('ລາຍການOrderພັດສະດຸ.ຈັດສົ່ງສຳເລັດ')},
                {id: 'cancelled', name: this.$t('externalShipments.status_cancelled')},
            ],

            la_pay_type: {
                'origin_freight_fees': this.$t('ລາຍການOrderພັດສະດຸ.ເກັບເງິນຕົ້ນທາງ'),
                'destination_freight_fees': this.$t('externalShipments.pay_type_destination_cdc'),
                'origin_freight_fees_cod': this.$t('ລາຍການOrderພັດສະດຸ.ເກັບເງິນຕົ້ນທາງ ( COD )'),
                'destination_freight_fees_cod': this.$t('ລາຍການOrderພັດສະດຸ.ເກັບເງິນປາຍທາງ ( COD + CDC )'),
            },
        };
    },
    methods: {
        nullsafe(instance, func) {
            try {
                return func(instance);
            } catch (_) {
                return undefined;
            }
        },
        disabledAfterToday(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return date > today;
        },
        fetchExternalOrdersResponse(options = {}) {
            const {current_page, per_page} = options;
            return this.$axios.get('external-shipments', {
                params: {
                    search: this.searchItem,
                    status_group: this.selectedStatusGroup,
                    branch_id: this.selectedStartBranch,
                    from_date: this.fromDate,
                    to_date: this.toDate,
                    page: current_page ?? this.pagination.current_page ?? 1,
                    per_page: per_page ?? this.per_page,
                },
            });
        },
        FetchData() {
            this.isLoading = true;
            this.fetchExternalOrdersResponse().then((res) => {
                this.listAllOrders = res.data.shipment.data;
                this.pagination = res.data.shipment;
                this.count = res.data.total;
                this.totalFreight = res.data.totalFreight;
                this.totalPrice = res.data.totalPrice;
                this.serviceFeeTotal = res.data.serviceFeeTotal;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });
        },
        FetchListStartBranch() {
            // Same branch listing the branch-orders page uses ($http = /api/).
            this.$http.get('v1/listing/branches?include=excluded').then((res) => {
                this.startBranches = res.data;
                this.startBranches.unshift({
                    id: '',
                    name: this.$t("common.ທັງໝົດ"),
                });
            }).catch(() => {
            });
        },
        FilterOrders() {
            this.pagination.current_page = 1;
            this.FetchData();
        },
        ExportOrders() {
            this.loading = true;
            this.$axios.get('external-shipments/export', {
                params: {
                    search: this.searchItem,
                    status_group: this.selectedStatusGroup,
                    branch_id: this.selectedStartBranch,
                    from_date: this.fromDate,
                    to_date: this.toDate,
                },
                responseType: 'blob',
            }).then((response) => {
                const fileUrl = window.URL.createObjectURL(new Blob([response.data]));
                const fileLink = document.createElement('a');
                fileLink.href = fileUrl;
                fileLink.setAttribute('download',
                    this.$t('externalShipments.orders_export_file_name', {startDate: this.fromDate, endDate: this.toDate}) + '.xlsx');
                document.body.appendChild(fileLink);
                fileLink.click();
                document.body.removeChild(fileLink);
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },
        ClearData() {
            this.searchItem = '';
            this.selectedStatusGroup = '';
            this.selectedStartBranch = '';
            this.fromDate = moment(new Date()).subtract(7, 'days').format('YYYY-MM-DD');
            this.toDate = moment(new Date()).format('YYYY-MM-DD');
            this.FilterOrders();
        },
    },
}
